import Icons from "../../Constants/Icons";
import "./Header.css";
import { useEffect, useState } from 'react';


const Header = () => {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > window.innerHeight);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header className={`luxury-header ${isSticky ? "sticky-header" : "sticky-header"}`}>
            <div className="container">
                <div className="logo"><img src={Icons.logo} alt={Icons.logo} style={{ height: "120px" }} /></div>
            </div>
        </header>
    );
};

export default Header;
